module.exports = __webpack_public_path__ + "media/images/icon/icons8-Menu 2 Filled-0f31610f577c85e35aa70bc9d0f9b66b.png";